import { devicesDataSelectorConfig } from './list'

export const selectorsConfig = {
  ...devicesDataSelectorConfig,
}
